<template>
  <div class="shop-menu-agent-mode-wall main" @click.once="showHelp = false">
    <div class="header">
      <svgicon
        icon="tuk-word"
        width="40"
        height="40"
        color="navy"
        :fill="true"
        style="margin-top: -10px; margin-left: 4px"
        @click="showDefaults"
      ></svgicon>
      <i class="tuk-express">EXPRESS</i>
      <i class="fa fa-info-circle fa-lg" @click="showAgentModeInfo" />
    </div>

    <div v-if="!agentModeData && showHelp" class="help-wrapper">
      <p class="title">What is TUK Express?</p>
      <p>- Send orders to customers</p>
      <p>or</p>
      <p>- Receive goods from suppliers</p>
    </div>

    <div ref="scrollable" class="wrapper no-scrollbar">
      <div class="details" style="margin-top: -12px">
        <p class="key">
          {{ $t("Delivery Mode") }}
          <!-- <i class="fa fa-cog is-pulled-right" @click="showDefaults" /> -->
          <span class="delivery-fee has-text-link" @click="vehicleInfo">
            <i class="fa fa-motorcycle" />&nbsp;Motorbike</span
          >
        </p>
        <p class="field is-flex">
          <span
            class="button mode-btn"
            :class="{ selected: isSend }"
            style="margin-right: 1px"
            @click="setMode('send')"
          >
            <i class="fa fa-share" style="margin-right: 4px" />
            Send
          </span>
          <span
            class="button mode-btn"
            :class="{ selected: isReceive }"
            style="margin-left: 1px"
            @click="setMode('receive')"
          >
            <i class="fa fa-hands" style="margin-right: 4px" />
            Receive
          </span>
        </p>
        <!-- <collapse-transition> -->
        <!-- <p v-if="showModeInfo" class="notification mode-info selected"> -->
        <p v-if="!address" class="notification mode-info selected">
          <i v-if="isSend">
            <!-- <i class="fa fa-share" /> -->
            Driver will come to your shop to pickup the goods and dropoff at
            customer's address
          </i>
          <i v-else>
            <!-- <i class="fa fa-hands" /> -->
            Driver will go to your supplier's address to pickup the goods and
            dropoff at your shop
          </i>
        </p>
        <!-- </collapse-transition> -->

        <p class="key">
          <span v-if="isSend"
            ><i class="far fa-user" />&nbsp;{{ $t("Customer Details") }}</span
          >
          <span v-else
            ><i class="fa fa-briefcase" />&nbsp;{{
              $t("Supplier Details")
            }}</span
          >
          <span class="change link" @click="checkPrice">
            <span v-if="!phoneNumber" class="has-text-link">Check Price?</span>
          </span>
        </p>

        <div v-if="isTest" class="field">
          <p class="notification is-light has-text-grey" @click="clearTest">
            <span class="has-text-weight-medium">Price Check / Test Order</span>
            <span class="tag is-white has-text-link real-order"
              >Real Order?</span
            >
          </p>
        </div>
        <div v-else>
          <div class="field has-addons">
            <div class="control is-expanded">
              <input
                ref="phoneInput"
                class="input is-medium"
                :class="{ 'is-danger': highlightMobileInput }"
                v-model="phoneNumber"
                placeholder="📞 Phone Number"
              />
            </div>
            <div class="control">
              <input
                class="input is-medium"
                style="width: 160px; padding-right: 0"
                placeholder="👤 Name"
                v-model="customerName"
              />
            </div>
          </div>
          <!-- TODO -->
          <!-- <p style="text-align: center; color: grey; margin-bottom: 6px">OR</p>
          <div class="notification is-white">
            <p @click="getCustomerList">
              <i class="far fa-user fa-sm" style="margin-right: 6px" />
              <span class="has-text-weight-medium">
                Lookup Previous Customer
              </span>
              <i :class="chevronRight" />
            </p>
          </div> -->
        </div>

        <div
          v-if="phoneNumber && phoneNumber.length > 4"
          class="notification is-white"
          :class="{ selected: address }"
        >
          <div v-if="address">
            <p @click="enterAddress">
              <i class="fa fa-map-marker-alt fa-sm" style="margin-right: 6px" />
              <span v-if="isSend">Customer Address</span>
              <span v-else>Supplier Address</span>
              <span class="edit-btn">Edit</span>
            </p>
            <p class="smaller" style="margin-bottom: 4px; color: blue">
              {{ address.name || "Pin Location" }}
            </p>
            <input
              class="input is-fullwidth is-grey"
              type="text"
              placeholder="Unit #, house #, condo name, instructions"
              v-model="addressNotes"
            />
          </div>
          <div v-else @click="enterAddress">
            <p>
              <i class="fa fa-map-marker-alt fa-sm" style="margin-right: 6px" />
              <span class="has-text-weight-medium">
                <span v-if="isSend">Enter Customer's Address</span
                ><span v-else>Enter Supplier's Address</span>
              </span>
              <i :class="chevronRight" />
            </p>
            <p class="smaller">
              <i>Set the delivery location</i>
            </p>
          </div>
        </div>

        <!-- <p class="key">
          {{ $t("Delivery Address Notes") }}
          <i class="change">Optional</i>
        </p>
        <p class="field">
          <input
            class="input is-fullwidth"
            type="text"
            placeholder="Unit #, house #, condo name"
            v-model="driverInstructions"
          />
        </p> -->

        <div v-if="address">
          <p class="key">{{ $t("Payment Options") }}</p>

          <div
            v-if="!payment || isShopPay"
            class="notification is-white"
            :class="{ selected: isShopPay }"
            @click="setPayment('shop')"
          >
            <p>
              <i class="fa fa-store-alt fa-sm" style="margin-right: 6px" />
              <span class="has-text-weight-medium">Shop Handles Payment</span>
              <span v-if="isShopPay" class="edit-btn">Edit</span>
              <i v-else :class="chevronRight" />
            </p>
            <div v-if="isShopPay">
              <div v-if="isSend">
                <p class="smaller">
                  <i>Shop collects payment from customer</i>
                </p>
                <p class="smaller">
                  <i>Shop pays the driver</i>
                  <!-- <i class="is-pulled-right has-text-primary" style="font-size: 0.8em; font-weight: 500" >Coming Soon!</i> -->
                </p>
              </div>
              <div v-else>
                <p class="smaller">
                  <i>Shop pays the supplier</i>
                </p>
                <p class="smaller">
                  <i>Shop pays the driver</i>
                  <!-- <i class="is-pulled-right has-text-primary" style="font-size: 0.8em; font-weight: 500" >Coming Soon!</i> -->
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="!payment || isDriverPay"
            class="notification is-white"
            :class="{ selected: isDriverPay }"
            @click="setPayment('driver')"
          >
            <p>
              <i class="fa fa-motorcycle fa-sm" style="margin-right: 6px" />
              <span class="has-text-weight-medium">Driver Handles Payment</span>
              <span v-if="isDriverPay" class="edit-btn">Edit</span>
              <span v-else :class="chevronRight" />
            </p>
            <div v-if="isDriverPay">
              <div v-if="isSend">
                <p class="smaller"><i>Driver pays the shop</i></p>
                <p class="smaller"><i>Customer pays the driver</i></p>
              </div>
              <div v-else>
                <p class="smaller"><i>Driver pays the supplier</i></p>
                <p class="smaller"><i>Shop pays the driver</i></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="payment">
        <p class="key">
          {{ $t("Delivery Address") }}
          <span class="change has-text-info">Max 16km</span>
        </p>
        <div
          class="notification is-white"
          :class="{ selected: address }"
          @click="enterAddress"
        >
          <p>
            <i class="fa fa-map-marker-alt fa-sm" style="margin-right: 6px" />
            <span class="has-text-weight-medium">
              <span v-if="isSend">Enter Customer's Address </span
              ><span v-else>Enter Supplier's Address</span>
            </span>
            <i
              class="fa fa-chevron-right fa-lg is-pulled-right"
              style="padding: 6px 0"
            />
          </p>
          <p class="smaller">
            <i>You set the delivery location</i>
          </p>
        </div>
        <div
          class="notification is-white"
          style="background-color: #eee; opacity: 0.7; color: grey"
          @click="preRequestAddress"
        >
          <p>
            <i class="fa fa-user fa-sm" style="margin-right: 6px" />
            <span class="has-text-weight-medium"
              >Customer Sets Their Address</span
            >
            <i
              class="fa fa-chevron-right fa-lg is-pulled-right"
              style="padding: 6px 0"
            />
          </p>
          <p class="smaller">
            <i>Customer sets their location</i>
          </p>
        </div>
      </div> -->

      <div v-if="deliveryFee && payment" class="details">
        <p class="key">
          {{ $t("Who will pay the delivery fee?") }}
          <span class="delivery-fee has-text-link" @click="deliveryFeeInfo"
            >{{ currency }}{{ deliveryFee }}</span
          >
        </p>

        <div
          v-if="
            isDriverPay && (!whoPaysDelivery || whoPaysDelivery === 'customer')
          "
          class="notification is-white"
          :class="{ selected: whoPaysDelivery === 'customer' }"
          @click="whoPays('customer')"
        >
          <p>
            <i class="fa fa-user" style="margin-right: 6px" />
            <span class="has-text-weight-medium"
              >Customer Pays Delivery Fee</span
            >
            <span v-if="whoPaysDelivery === 'customer'" class="edit-btn"
              >Edit</span
            >
            <span v-else :class="chevronRight" />
          </p>
          <!-- <p><i>Delivery fee will be added to the customer bill</i></p> -->
        </div>
        <div
          v-if="!whoPaysDelivery || whoPaysDelivery === 'shop'"
          class="notification is-white"
          :class="{ selected: whoPaysDelivery === 'shop' }"
          @click="whoPays('shop')"
        >
          <!-- style="background-color: #eee; opacity: 0.7" -->
          <p>
            <i class="fa fa-store-alt" style="margin-right: 6px" />
            <span class="has-text-weight-medium">Shop Pays Delivery fee</span>
            <span v-if="isDriverPay && !isReceive">
              <span v-if="whoPaysDelivery === 'shop'" class="edit-btn"
                >Edit</span
              >
              <span v-else :class="chevronRight" />
            </span>
          </p>
          <!-- <p><i>Delivery fee will be deducted from the shop's</i></p> -->
        </div>

        <div v-if="whoPaysDelivery" style="margin-top: 10px">
          <p class="key">{{ $t("What is the cost of the goods?") }}</p>

          <div
            v-if="costOfGoods != null"
            class="notification is-white selected"
          >
            <p>
              <i class="fa fa-coins" style="margin-right: 6px" />
              <span class="has-text-weight-medium"
                >Price of Goods
                <span class="has-text-link"
                  >{{ currency }}{{ costOfGoods }}</span
                >
              </span>
              <span class="edit-btn" @click="costOfGoods = null">Edit</span>
            </p>
            <table class="table is-fullwidth">
              <tr v-for="(o, idx) in goods" :key="idx">
                <td>
                  <span class="qty-left">{{ o.quantity }}</span>
                  {{ o.name }}
                </td>
                <td>{{ currency }}{{ o.price }}</td>
              </tr>
            </table>

            <input
              class="input is-fullwidth is-grey"
              type="text"
              placeholder="Additional order notes"
              v-model="orderNotes"
            />
          </div>
          <div v-else>
            <div class="field has-addons">
              <!-- <div class="control">
              <a class="button" style="border-radius: 0">
                <span class="icon">
                  <i class="fa fa-coins" />
                </span>
              </a>
            </div> -->
              <div class="control is-expanded">
                <input class="input" v-model="costOfGoodsName" />
              </div>
              <div class="control has-icons-left">
                <span
                  class="icon is-small is-left"
                  style="width: 25px; color: grey"
                  >{{ currency }}</span
                >
                <input
                  class="input"
                  style="width: 90px; padding-left: 18px; padding-right: 0"
                  type="number"
                  placeholder="Price"
                  v-model="costOfGoodsPrice"
                />
              </div>
              <!-- <div class="control">
                <a
                  class="button"
                  style="padding: 12px"
                  @click="setCostOfGoods(costOfGoodsPrice)"
                >
                  <i class="fa fa-chevron-right fa-lg" />
                </a>
              </div> -->
            </div>

            <!-- <div
              v-if="isSend"
              class="notification is-white"
              @click="enterItemisedOrder"
            >
              <p>
                <i class="fa fa-list-ol" style="margin-right: 6px" />
                <span class="has-text-weight-medium">Enter Itemised Order</span>
                <i :class="chevronRight" />
              </p>
            </div> -->

            <div class="field is-grouped">
              <p class="control">
                <span class="button is-medium" @click="setCostOfGoods(0)">{{
                  $t("transport.skip")
                }}</span>
              </p>
              <p class="control is-expanded">
                <span
                  class="button is-medium is-fullwidth"
                  @click="setCostOfGoods(costOfGoodsPrice)"
                  >{{ $t("next") }}
                  <i class="fa fa-chevron-right" style="margin-left: 6px" />
                </span>
              </p>
            </div>

            <!-- <div
              class="notification is-light has-text-right"
              @click="setCostOfGoods(0)"
            >
              <p>
                <span class="has-text-weight-medium">Skip</span>
              </p>
            </div> -->
          </div>

          <div v-if="costOfGoods != null" style="margin-top: 24px">
            <span
              v-if="isTest"
              class="button is-fullwidth is-danger is-medium pulse"
              @click="preSubmit"
              >Place Order TEST</span
            >
            <span
              v-else
              class="button is-fullwidth is-success is-medium pulse"
              @click="preSubmit"
              >Place Order</span
            >
            <p v-if="isTest" style="margin-top: 20px; text-align: center">
              <i class="has-text-grey" @click="focusPhoneInput">
                <span class="link"
                  >Enter mobile number to place a real order</span
                >
                <i class="fa fa-chevron-right" style="margin-left: 8px" />
              </i>
            </p>
          </div>
        </div>
      </div>
      <div style="height: 50px" />
    </div>
    <div v-if="isUnavailable" class="unavailable" @click="$router.go(-1)">
      <p style="margin-bottom: 20px">
        Currently unavailable due to Loi Krathong
      </p>
      <p>ไม่สามารถใช้งานได้ในขณะนี้เนื่องจากเทศกาล</p>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus";
import { sounds } from "../functions.js";

export default {
  name: "ShopMenuAgentModeWall",
  components: {},
  props: {
    agentModeData: Object, // if editing previously entered data
    address: Object, // delivery address
    business: Object, // transport workflow, should be array
    commerce: Object, // commerce workflow data obj
    currency: String,
    deliveryFee: Number,
  },
  data() {
    return {
      showHelp: true,
      isTest: false,
      // showModeInfo: false,
      mode: "send",
      payment: null, //"driver", // user will set payment method
      phoneNumber: null,
      customerName: null,
      highlightMobileInput: false,
      addressNotes: null,
      orderNotes: null,
      whoPaysDelivery: null,
      costOfGoods: null,
      // costOfGoodsInput: null,
      costOfGoodsName: "Goods",
      costOfGoodsPrice: null,
      receiptType: null, // simple, itemised, skip
      modeInfoTime: null, //this.addTimeToModeInfo(),
      counter: 0,
      chevronRight: "fa fa-chevron-right fa-lg is-pulled-right chevron-select",
    };
  },
  computed: {
    isUnavailable() {
      return false;
    },
    isSend() {
      return this.mode === "send";
    },
    isReceive() {
      return this.mode === "receive";
    },
    isDriverPay() {
      return this.payment === "driver";
    },
    isShopPay() {
      return this.payment === "shop";
    },
    goods() {
      // if itemised basket use that, otherwise:
      return [
        {
          name: this.costOfGoodsName,
          price: this.costOfGoods, // set from costOfGoodsPrice
          quantity: 1, // maybe not needed ?
        },
      ];
    },
    defaults() {
      return this.commerce.tuk_express;
    },
    showModeInfo() {
      console.log("counter", this.counter);
      return this.modeInfoTime > new Date();
    },
    customerNameWithFallback() {
      var name = this.customerName;
      if (this.isSend) return name || "Customer";
      else return name || "Supplier";
    },
    payload() {
      return {
        mode: this.mode,
        mobile: this.parsePhone(),
        customerName: this.customerNameWithFallback,
        addressNotes: this.addressNotes,
        payment: this.payment,
        whoPaysDelivery: this.whoPaysDelivery,
        goods: this.goods,
        orderNotes: this.orderNotes || "",
        isTest: this.isTest,
      };
    },
  },
  mounted() {
    if (this.agentModeData) {
      this.phoneNumber = this.agentModeData.mobile;
      this.payment = this.agentModeData.payment;
    } else {
      // var msg = `<p style='font-weight:550; margin-bottom:8px; font-size:1.1em'>What is TUK Express?<p><p>- Send orders to customers or</p><p>- Receive goods from suppliers</p>`;
      // this.infoToast(msg, "bottom", 8000);
      this.setDefaults();
    }
    if (!this.address) {
      this.triggerShowModeInfo();
    }
    setInterval(() => (this.counter += 1), 1000);
  },
  methods: {
    clearTest() {
      this.isTest = false;
      this.phoneNumber = null;
      this.customerName = null;
    },
    getCustomerList() {
      // lookup customers for this shop, need to create API
    },
    triggerShowModeInfo() {
      this.addTimeToModeInfo();
      //   this.showModeInfo = true;
      //   setTimeout(() => (this.showModeInfo = false), 8000);
    },
    addTimeToModeInfo() {
      this.modeInfoTime = new Date();
      this.modeInfoTime.setSeconds(this.modeInfoTime.getSeconds() + 10);
    },
    setDefaults() {
      if (!this.defaults) {
        // could use fallback defaults here
        return;
      }
      this.mode = this.defaults.mode;
      this.payment = this.defaults.payment;
      this.whoPaysDelivery = this.defaults.who_pays;
      this.receiptType = this.defaults.receipt; // simple, itemised, skip
    },
    showDefaults() {
      if (!this.$store.getters.isSuperUser) {
        var text = `Contact TUK Support to set up<br>default settings tailored<br>to your business needs`;
        this.successToast(text, "top", 9000);
        return;
      }
      var msg = this.defaults || "<i>No Defaults</i>";
      var prefix = `<p style='font-size:1.1em; font-weight: 500;margin-bottom:6px'>TUK Express Settings</p>`;
      this.infoToast(prefix + msg, "top", 12000);
    },
    focusPhoneInput() {
      this.isTest = false;
      this.phoneNumber = null;
      setTimeout(() => this.$refs.phoneInput.focus(), 500);
    },
    setCostOfGoods(cost) {
      this.costOfGoods = parseFloat(cost || 0); // parseInt?
      this.scrollToBottom();
    },
    setMode(mode) {
      this.mode = mode;
      if (mode === "receive") {
        // apply constraints
        this.whoPaysDelivery = "shop";
      }
      this.triggerShowModeInfo();
    },
    checkPrice() {
      if (this.isTest) {
        this.isTest = false;
        this.phoneNumber = null;
        this.customerName = null;
      } else {
        this.isTest = true;
        this.phoneNumber = "+66909588716";
        this.customerName = "Test Customer";
      }
    },
    scrollToBottom() {
      setTimeout(() => {
        this.$refs.scrollable.scrollTo({ top: 9999, behavior: "smooth" });
      }, 300);
    },
    deliveryFeeInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-motorcycle'></i>&nbsp;Delivery Fee</p>
        <p style='margin-bottom:10px'>Delivery fee is calculated based on your shop location and the address provided for the other party.</p>
        <p><i>The delivery fee for this order is 
        <strong>${this.currency}${this.deliveryFee}</strong>
        </i></p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    vehicleInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-motorcycle'></i>&nbsp;Vehicle Info</p>
        <p style='margin-bottom:10px'>
        TUK Express vehicles are motorbikes with food delivery boxes.
        </p>
        <p>
       <i>If you require a different type of vehicle for your delivery (such as a car or truck) do not use TUK Express.</i>
        </p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    whoPays(who) {
      if (this.whoPaysDelivery) {
        if (this.isShopPay) {
          var msg = `When shop is handling payment<br>the shop also pays the delivery fee`;
          this.infoToast(msg, "top", 12000);
          return;
        }
        if (this.isReceive) {
          var msg2 = `For receiving a supplier order<br>the shop pays the delivery fee`;
          this.infoToast(msg2, "top", 12000);
          return;
        }
        this.whoPaysDelivery = null; //this.clearWhoPaysDelivery()
        return;
      }
      this.scrollToBottom();
      // setTimeout(() => this.scrollToBottom(), 600);
      this.whoPaysDelivery = who;
    },
    showAgentModeInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
<p  style='font-size:1.2em'>
    <i class='fa fa-shipping-fast'></i>&nbsp;TUK Express
</p>
<p style='margin-top:12px'>
    Arrange deliveries to your customers or receive orders from your suppliers.
</p>
<p style='margin-top:10px'>
  Perfect for those regular customers who call you on the phone <i class='fa fa-phone fa-sm has-text-grey'></i> 
  or message <i class='far fa-comment-alt fa-sm has-text-grey'></i>  you on LINE <i class='fab fa-line fa-sm has-text-success'></i>
  or Facebook <i class='fab fa-facebook fa-sm has-text-link'></i> .
</p>
<p style='margin-top:10px'>
    Delivery starting from ฿30!
</p>
</div>`,
        showCloseButton: true,
        confirmButtonText: "Questions? Message Us!",
      }).then((val) => {
        if (val.value) this.contactFBMessengerSupport();
      });
    },
    clearPayment() {
      this.payment = null;
      this.whoPaysDelivery = null;
    },
    setPayment(method) {
      this.cleanPhone(); // clean it
      if (this.payment) {
        this.clearPayment();
        return;
      }
      this.log("set_agent_mode_payment", method);
      this.payment = method;
      if (this.isShopPay || this.isReceive) this.whoPaysDelivery = "shop";
      else this.whoPaysDelivery = null;
      this.scrollToBottom();
    },
    close() {
      this.$emit("close");
    },
    cleanPhone() {
      if (!this.phoneNumber) return;
      this.phoneNumber = this.phoneNumber.replace(/[^0-9\+]+/g, ""); // replace anything that's not a number or period
    },
    parsePhone() {
      var s = this.phoneNumber;
      // check if contains any non-numeric chars after initial +
      // TODO
      // assume a + country code is correct, just remove any white spaces
      if (s[0] === "+") return s.replace(/\s+/g, "");
      // assume starting with 0 means thai number
      if (s[0] === "0") return "+66" + s.substring(1).replace(/\s+/g, "");
      // otherwise invalid
      return null;
    },
    preRequestAddress() {
      if (!this.phoneNumber) {
        sounds("unsafe");
        return this.errorToast("Enter mobile phone number", "top");
      }
      var msg = `Customer set address coming soon!<br>For now enter it yourself 🙏🏼`;
      this.infoToast(msg);
      return;
    },
    validPhoneNumber() {
      if (!this.phoneNumber) {
        sounds("unsafe");
        this.highlightMobileInput = true;
        this.errorToast("Enter a phone number", "top");
        return false;
      }
      if (this.phoneNumber.length < 9) {
        sounds("unsafe");
        this.errorToast("Invalid phone number", "top");
        return false;
      }
      if (!this.parsePhone()) {
        sounds("unsafe");
        this.errorToast("Invalid phone number", "top");
        return false;
      }
      return true;
    },
    enterAddress() {
      if (!this.validPhoneNumber()) return;
      this.log("tuk_express_enter_address");
      var data = {
        payment: this.payment,
        mobile: this.parsePhone(),
        mode: this.mode,
      };
      this.$emit("enterAddress", data);
      // this.close();
      this.$toast.clear();
    },
    preSubmit() {
      // check everything is valid, then create order
      if (!this.phoneNumber) {
        this.errorToast("Enter a phone number above");
        return;
      }
      this.placeOrder();
    },
    placeOrder() {
      this.log("tuk_express_place_order", this.payload);
      var msg = `🦄 TUK Express order placed by ${this.$store.getters.getNameAndNumber} @ ${this.business.name}`;
      this.sendSuperuserNotification(msg);
      this.$emit("placeOrder", this.payload);
    },
    enterAmount() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-coins'></i>&nbsp;Enter price of goods
        </p>
        <p style='margin-bottom:10px'>Enter the cost of the goods to charge the customer.</p>
        <p><i>The delivery fee will be added to this amount.</i></p>
        </div>`,
        input: "number",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Enter",
        inputValidator: (val) => {
          if (!val) return "Enter a valid amount";
        },
      }).then((val) => {
        if (!val.value) return;
        this.reallySubmit(val.value);
      });
    },
    enterItemisedOrder() {
      this.reallySubmit(null);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  width: 100vw;
  max-width: 700px;
  bottom: 0;
  height: calc(100vh - 100px);
  background-color: whitesmoke;
  /* background-color: white; */
  z-index: 21;
  overflow: hidden;
}
.wrapper {
  padding: 6px 12px;
  text-align: left;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
}
.header {
  position: relative;
  z-index: 2;
  width: 100%;
  /* opacity: 0.9; */
  /* margin-bottom: 0; */
  /* vertical-align: top; */
  line-height: 35px;
  text-align: left;
  height: 50px;
  padding: 10px;
  background-color: white;
  box-shadow: 0 0 4px grey;
}
.subtitle {
  position: relative;
  width: 100%;
  display: inline-block;
  opacity: 0.9;
  /* font-weight: 450; */
  margin-bottom: 0;
  vertical-align: top;
  line-height: 35px;
  margin-top: -3px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
img {
  display: inline-block;
  /* position: absolute; */
  /* left: 12px; */
  height: 35px;
  /* background-color: white; */
}
.notification {
  padding: 6px 12px;
  margin-bottom: 6px;
  border: 1px solid #bbb;
  width: 100%;
}
.amount {
  display: inline-block;
  width: 40px;
}
.key {
  margin-top: 16px;
  font-weight: 550;
  color: rgba(47, 47, 47, 0.6);
  /* margin-right: 6px; */
  /* width: 90px; */
}
.address-notes {
  line-height: 1;
}
.pulse {
  animation: shadow-pulse-gold 1.5s infinite;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px gold;
  }
  100% {
    box-shadow: 0 0 0 8px rgba(255, 217, 0, 0.4);
  }
}
@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(0, 255, 255, 0.3);
  }
}
.fa-pencil-alt {
  /* color: lightgreen; */
  margin-left: 6px;
}
.details {
  margin: 10px 0;
}
.details p {
  line-height: 1.8em;
}
.choose-one {
  position: absolute;
  right: 10px;
  font-size: 0.85em;
  padding: 4px;
  margin-bottom: 8px;
  color: blue;
  background-color: rgb(255, 242, 0);
  border-radius: 4px;
}

.is-test {
  margin-top: -4px;
  font-size: 0.8em;
}
.grey {
  font-weight: 600;
  color: rgb(151, 151, 151);
  font-size: 0.7em;
  margin-left: 6px;
  /* text-decoration: underline overline; */
}
.link {
  border-bottom: 1px #ccc dotted;
}
.buttons .button {
  margin-bottom: 14px;
}
.buttons .fa {
  font-size: 1.5em;
}
.buttons .button span {
  /* width: 100px; */
  margin-left: 12px;
  /* text-align: right; */
  font-weight: 550;
}
.optional {
  position: absolute;
  right: 18px;
  margin-top: 28px;
  /* left: 116px;
  margin-top: -5px; */
  font-size: 0.7em;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.5);
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.6);
  line-height: 1;
  padding: 2px;
  border-radius: 3px;
}
/* .optional {
  font-size: 0.7em;
  font-weight: 550;
} */

.test-btn {
  float: right;
  padding-top: 4px;
  padding-right: 4px;
  color: grey;
  font-size: 0.8em;
  line-height: 1.4;
}
.change {
  float: right;
  font-weight: 500;
  font-size: 0.85em;
  line-height: 1.3em;
  margin-top: 4px;
  /* opacity: 0.8; */
  color: black;
}
.selected {
  background-color: rgb(206, 249, 255);
}
.selected.mode-btn {
  /* flex-grow: 2 !important; */
  width: calc(100vw - 200px);
}
.smaller {
  font-size: 0.95em;
  opacity: 0.7;
  margin: 0;
  padding: 0;
  line-height: 1.4em !important;
}
.is-flex .button {
  flex-grow: 1;
  font-weight: 500;
}
.mode-btn {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.mode-info {
  margin-top: -8px;
  padding-top: 8px;
  border-top: 0px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  font-size: 0.95em;
  line-height: 1.4em !important;
  background-color: rgba(0, 0, 0 0);
}
.delivery-fee {
  float: right;
  line-height: 1.2em;
  font-weight: 500;
  border-bottom: 1px #444 dotted;
}
.edit-btn {
  line-height: 1.2em;
  margin-top: 3px;
  font-weight: 500;
  font-size: 0.8em;
  float: right;
  border-bottom: 1px #444 dotted;
}
.tuk-express {
  font-size: 16pt;
  font-weight: 550;
  color: #fac002;
  position: absolute;
  margin-top: 1px;
  margin-left: 3px;
  /* text-shadow: 0 0 2px white, 0 0 2px white, 0 0 2px white; */
}
.white-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 50px;
  width: 100vw;
  background-color: white;
  z-index: 0;
}
.chevron-select {
  padding: 6px 0;
}
.field {
  margin-bottom: 6px;
}
.button.pulse {
  font-weight: 500;
}
.qty-left {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 7px;
  padding-top: 3px;
  /* margin-bottom: 2px; */
  border-radius: 3px;
  border: 1px solid #209cee;
  font-weight: 500;
  margin-right: 4px;
}
.table {
  background-color: rgb(247, 247, 247);
  margin-bottom: 6px;
  border-radius: 3px;
}
td {
  border-bottom: 0px;
}
.fa-cog {
  opacity: 0.6;
  padding: 2px;
}
.help-wrapper {
  position: absolute;
  bottom: 0;
  width: calc(100% - 20px);
  max-width: 700px;
  padding: 16px 10px;
  /* background-color: white; */
  background-color: whitesmoke;
  margin: 10px;
  border-radius: 4px;
  box-shadow: 0 0 2px grey;
}
.help-wrapper .title {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 1.2em;
  color: grey;
}
.fa-info-circle {
  padding: 7px 2px;
  opacity: 0.3;
  float: right;
}
.real-order {
  margin-top: 3px;
  box-shadow: 0 0 1px grey;
  font-weight: 500;
  float: right;
}
.unavailable {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: var(--danger);
  /* background-color: rgba(255, 0, 0, 0.9); */
  color: white;
  padding: 100px 20px;
  font-size: 2em;
  /* backdrop-filter: blur(3px); */
}
</style>